import httpClient from '../utils/httpClient';

const API = '/academic';

export const getStudentTranscript = async (studentId) => httpClient.get(`${API}/transcript/${studentId}`);
export const getStudentAlerts = async (studentId) => {
  const url = studentId ? `${API}/alerts?studentId=${studentId}` : `${API}/alerts`;
  return httpClient.get(url);
};
export const getCalendarEvents = async (year) => httpClient.get(`${API}/calendar?year=${year || new Date().getFullYear()}`);
export const createCalendarEvent = async (data) => httpClient.post(`${API}/calendar`, data);
export const updateCalendarEvent = async (id, data) => httpClient.put(`${API}/calendar/${id}`, data);
export const deleteCalendarEvent = async (id) => httpClient.delete(`${API}/calendar/${id}`);
export const getClassrooms = async () => httpClient.get(`${API}/classrooms`);
export const createClassroom = async (data) => httpClient.post(`${API}/classrooms`, data);
export const updateClassroom = async (id, data) => httpClient.put(`${API}/classrooms/${id}`, data);
export const getInstitutionConfig = async () => httpClient.get(`${API}/institution-config`);
export const updateInstitutionConfig = async (data) => httpClient.put(`${API}/institution-config`, data);

const buildFallbackCertificateFilename = (type, personName) => {
  const ymd = new Date().toISOString().slice(0, 10);
  const prefix = type === 'transcript' || type === 'escolaridad' ? 'escolaridad' : type || 'certificado';
  const raw = String(personName || 'estudiante')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  return `${prefix}_${raw || 'estudiante'}_${ymd}.pdf`;
};

const parseFilenameFromContentDisposition = (header) => {
  if (!header) return null;
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/["']/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/["']/g, '');
    }
  }
  const plainMatch = header.match(/filename="?([^";]+)"?/i);
  return plainMatch?.[1]?.trim() || null;
};

export const downloadAcademicCertificatePdf = async (
  studentId,
  type = 'transcript',
  options = {},
) => {
  const token = localStorage.getItem('token');
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const response = await fetch(`${baseUrl}/academic/certificate/${type}/${studentId}/pdf`, {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  });
  if (!response.ok) throw new Error('Error al descargar certificado');
  const blob = await response.blob();
  const filename =
    parseFilenameFromContentDisposition(response.headers.get('Content-Disposition')) ||
    buildFallbackCertificateFilename(type, options.personName);
  return { blob, filename };
};

export const previewEscolaridadesFromDirectory = async (directoryPath) => {
  const body = { useDirectory: true };
  if (directoryPath) body.directoryPath = directoryPath;
  return httpClient.post(`${API}/import/escolaridades/preview`, body);
};

export const commitEscolaridadesFromDirectory = async (directoryPath, createdBy) => {
  const body = { useDirectory: true };
  if (directoryPath) body.directoryPath = directoryPath;
  if (createdBy) body.createdBy = createdBy;
  return httpClient.post(`${API}/import/escolaridades/commit`, body);
};

export const previewEscolaridadesImport = async (files) => {
  const form = new FormData();
  form.append('useDirectory', 'false');
  (files || []).forEach((f) => form.append('files', f));
  return httpClient.post(`${API}/import/escolaridades/preview`, form);
};

export const commitEscolaridadesImport = async (files, createdBy) => {
  const form = new FormData();
  form.append('useDirectory', 'false');
  if (createdBy) form.append('createdBy', String(createdBy));
  (files || []).forEach((f) => form.append('files', f));
  return httpClient.post(`${API}/import/escolaridades/commit`, form);
};
